import {IProfileItemModel, ProfileItemModel} from './profile-item.model';

export interface IWerdegang extends IProfileItemModel {
  uuid?: string;
  beginn?: Date | string;
  ende?: Date;
  unternehmen?: string;
  stellenbezeichnung?: string;
  ort?: string;
  taetigkeit?: string;
}

export class Werdegang extends ProfileItemModel implements IWerdegang {
  constructor(
    public uuid?: string,
    public beginn?: Date,
    public ende?: Date,
    public unternehmen?: string,
    public stellenbezeichnung?: string,
    public ort?: string,
    public taetigkeit?: string
  ) {
    super();
    this.beginn = beginn ? beginn : new Date(Date.now());
    this.ende = ende ? ende : undefined;
    this.unternehmen = unternehmen ? unternehmen : undefined;
    this.stellenbezeichnung = stellenbezeichnung ? stellenbezeichnung : undefined;
    this.ort = ort ? ort : undefined;
    this.taetigkeit = taetigkeit ? taetigkeit : undefined;
  }

  static emptyObject(): Werdegang {
    const data = new Werdegang();
    data.beginn = new Date();
    data.ende = new Date();
    data.unternehmen = '';
    data.stellenbezeichnung = '';
    data.ort = '';
    data.taetigkeit = '';
    return data;
  }

  static fromJson(json: IWerdegang) {
    const data = new Werdegang();
    data.uuid = json.uuid;
    data.unternehmen = json.unternehmen;
    data.stellenbezeichnung = json.stellenbezeichnung;
    data.ort = json.ort;
    data.taetigkeit = json.taetigkeit;
    data.beginn = this.anyToDate(json.beginn);
    data.ende = this.anyToDate(json.ende);
    return data;
  }

  newInstance<T extends ProfileItemModel>(): T {
    return new Werdegang() as T;
  }
}
